// extracted by mini-css-extract-plugin
module.exports = {"default":"Layout-module--default--2sMAG","isDisabled":"Layout-module--isDisabled--3EDLk Layout-module--default--2sMAG"};